export class ScreenUtils {
  /**
   * Retorna a largura atual da tela
   */
  static getLargura(): number {
    return window.innerWidth;
  }

  /**
   * Retorna a altura atual da tela
   */
  static getAltura(): number {
    return window.innerHeight;
  }

  /**
   * Retorna um objeto com a resolução atual
   */
  static getResolucao(): { largura: number; altura: number } {
    return {
      largura: window.innerWidth,
      altura: window.innerHeight,
    };
  }

  /**
   * Verifica se a tela é considerada "pequena"
   */
  static isTelaPequena(breakpoint: number = 768): boolean {
    return window.innerWidth <= breakpoint;
  }
}
